import { ContentElementExternalLinks as CeExternalLinks } from '@vgn-medien-holding/vgn-fe-components';
import elementStyle from './styles/default';

export default function ContentElementExternalLinks(element) {
  return (
    <div className="md:px-16 xl:px-32">
      <CeExternalLinks element={element} classProps={elementStyle} />
    </div>
  );
}
